import { safeLocalStorage } from '@/shared/lib'
import { readCloudItem, writeCloudItem } from '@/shared/telegram'

/**
 * Онбординг (экран 01) показывается один раз (CLAUDE.md, «Состояние»).
 *
 * Флаг `onboarded` живёт в `CloudStorage` Telegram — он общий для всех
 * устройств пользователя, — и копией в `localStorage` нашего домена: копия
 * читается синхронно (повторный запуск не ждёт Telegram ни миллисекунды) и
 * выручает вне Telegram и на клиентах без `CloudStorage`.
 */
const CLOUD_KEY = 'onboarded'

const LOCAL_KEY = 'tapgift.onboarded'

const DONE = '1'

/**
 * Сколько первый запуск на устройстве ждёт ответа `CloudStorage` (обычно он
 * приходит за 100–300 мс). Дольше первый экран не держим: молчание — как
 * «не пройден», онбординг короткий и пропускается одной ссылкой.
 */
const CLOUD_TIMEOUT_MS = 800

/** Пройден ли онбординг, по копии на устройстве — без ожидания. */
export const isOnboardedLocally = (): boolean => safeLocalStorage.getItem(LOCAL_KEY) === DONE

/**
 * Пройден ли онбординг: копия на устройстве, затем `CloudStorage`. Ответ
 * Telegram «пройден» запоминается и на устройстве.
 */
export const readOnboarded = async (): Promise<boolean> => {
  if (isOnboardedLocally()) {
    return true
  }

  const cloud = await readCloudItem(CLOUD_KEY, CLOUD_TIMEOUT_MS)

  if (cloud !== DONE) {
    return false
  }

  safeLocalStorage.setItem(LOCAL_KEY, DONE)

  return true
}

/** «Начать» или «Пропустить»: больше не показывать — ни здесь, ни на других устройствах. */
export const markOnboarded = (): void => {
  safeLocalStorage.setItem(LOCAL_KEY, DONE)
  writeCloudItem(CLOUD_KEY, DONE)
}
